import { Callout } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { Section } from "~/components/Section/Section";
const DeprecatedEndpoint: React.FC = () => {
    return (<Section>
            <Callout type={"danger"} title="Deprecated">
                This endpoint has been deprecated and is no longer supported by the Octopus UI.
                <br />
                We recommend deleting this deprecated endpoint configuration.
            </Callout>
        </Section>);
};
DeprecatedEndpoint.displayName = "DeprecatedEndpoint"
export default DeprecatedEndpoint;
